/* 🤖 this file was generated by svg-to-ts */
export const mgcIconFlag1Filled: {
  name: 'flag-1-filled';
  data: string;
} = {
  name: 'flag-1-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.58 3.047c-.734.141-1.4.821-1.537 1.57C4.013 4.783 4 7.323 4 13c0 9.144-.026 8.376.299 8.701a.984.984 0 0 0 1.402 0c.307-.307.299-.224.299-3.128v-2.572l7.131-.011 7.131-.01.199-.102a.985.985 0 0 0 .502-1.099c-.044-.198-.242-.487-1.873-2.73-1.003-1.379-1.823-2.526-1.823-2.549s.82-1.17 1.823-2.549c1.631-2.243 1.829-2.532 1.873-2.73a.985.985 0 0 0-.502-1.099l-.199-.102-7.241-.006c-4.47-.003-7.317.009-7.441.033"/></svg>`
};
